<template>
  <div class="bg_gray" style="overflow:hidden;">
    <Header navTitle="我的实验" navPath="/mobile/center"></Header>
    <div class="container bg_gray">
     <LoadListPage v-if="exptList.length > 0" :pager="pager" v-model:loading="loading" v-model:finished="finished" @getPager="getPager">
      <ul class="expt_list_common">
          <li v-for="item in exptList" :key="item.id" >
            <div class="cover">
              <img v-if="item.cover_image" :src="item.cover_image" class="image" />
              <img v-else :src="require('assets/img/course/cover.png')" />
              <span class="hot" v-if="item.cover_image_label && item.cover_image_label != 'null'">{{ item.cover_image_label }}</span>
              <span class="tag" v-if="item.type">
                <span v-if="item.type == 'curriculum' ">课程实验</span>
                <span v-if="item.type == 'diy' ">开放实验</span>
              </span>
            </div>
            <div class="content">
              <h4 class="text_ellipsis">{{ item.name }}</h4>
              <div class="info text_ellipsis" v-if="item.type != 'diy'" @click="goPath(item)">所属课程:{{ item.belong }}</div>
              <div class="info text_ellipsis">运行状态:{{ item.state }}</div>
              <div class="btns">
                <van-button type="danger" size="mini" v-if="item.type != 'diy' " @click="delete_expt(item)">结束实验</van-button>
                <van-button type="danger" size="mini" v-else @click="close_diy_expt(item)">结束实验</van-button>
              </div>
            </div>
          </li>
      </ul>
      </LoadListPage>
      <van-empty v-else description="暂无内容哦~"></van-empty>
    </div>
  </div>
</template>

<script>
  import Header from 'components/mobile/common/Header'
  import LoadListPage from "components/mobile/common/LoadListPage"
  import { getExptList, deleteExpt, closeDiyExpt } from 'api/experiment/list'
  import { showConfirmMessageBox, showMessage } from 'api/base/mobile/message'
  export default {
    components: {
      Header,
      LoadListPage
    },
    data() {
      return {
        exptList:[],
        loading: false,
        finished: false,
        pager: {
          currentPage: 1,
          pageSize: 10,
          total: 0
        }
      }
    },
    mounted() {
      this.$emit('update:isShowHeader', false);
      this.getData()
      // this.getPager(this.pager)
    },
    methods: {
      getData() { console.log('getData');
        let data = {}
        data['offset'] = (this.pager.currentPage - 1) * this.pager.pageSize
        data['limit'] = this.pager.pageSize
        console.log(data);
        getExptList(data).then(res => { console.log(res);
          this.exptList.push(...res.data)
          this.pager.total = res.total
          this.loading = false
        }).catch(err => {
          showMessage(err)
        })
      },
      goPath(item) {
        this.$router.push('/mobile/course/detail/'  + item.curr_uuid)
      },
      getPager(pager) { //获取分页变化后数据
        this.pager = pager
        this.getData()
      },
      delete_expt(item){
        var data = {'uuid':item.uuid,'name':item.name}
        deleteExpt(data).then((res) => {
          if(res.data.code == 0){
            showMessage('结束成功！').then(() => {
              location.reload()
            })
//            this.getData()
          }else{
            this.$alert(`${res.data.err_message}`, '提示', {
              confirmButtonText: '确定',
            });
          }
        })
      },
      close_diy_expt(item){
        closeDiyExpt({'uuid':item.uuid,'name':item.name}).then((res) => {
          if(res.data.code == 0){
            showMessage('结束成功！').then(() => {
              location.reload()
            })
//            this.getData()
          }else{
            this.$alert(`${res.data.err_message}`, '提示', {
              confirmButtonText: '确定',
            });
          }
        })
      },
    }
  }
</script>

<style lang="scss" scoped>
  .container {
    padding: 10px 0;
    .list {
      margin-bottom:10px;
    }
    .course_item_common {
      .select {
        display: flex;
        padding-left: 10px;
      }
    }
  }
</style>
